import * as React from "react";
const SvgFiRrEclipse = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-eclipse_svg__a)">
      <path
        fill="#062147"
        d="M12 24a1 1 0 0 1-1-1v-4.079a6.8 6.8 0 0 1-1.623-.435L7.33 22.007A1.001 1.001 0 0 1 5.6 21l2.049-3.525a7 7 0 0 1-1.128-1.13L3.01 18.391A1.001 1.001 0 0 1 2 16.662l3.51-2.043A7 7 0 0 1 5.072 13H1a1 1 0 0 1 0-2h4.072a7 7 0 0 1 .445-1.626L2 7.326A1 1 0 0 1 3 5.6l3.528 2.049q.507-.636 1.143-1.142L5.627 2.992a1 1 0 1 1 1.728-1.006L9.4 5.5a7 7 0 0 1 1.609-.431L11 1a1 1 0 0 1 2 0v4.079a2 2 0 0 1-1.71 1.971A5.02 5.02 0 0 0 7 12c0 3.538 3.728 4.87 4.289 4.95A2 2 0 0 1 13 18.921V23a1 1 0 0 1-1 1m6-6c-7.929-.252-7.928-11.749 0-12 7.929.252 7.928 11.749 0 12m0-10c-5.275.138-5.274 7.863 0 8 5.275-.138 5.274-7.863 0-8"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-eclipse_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEclipse;
